// CategoryRow.js
import React, { useState } from "react";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import SortableItem from "../SortableItem/SortableItem";

import ToggleSwitch from "../../../../CommonComponents/ToggleSwitch/ToggleSwitch";

import ClipPath from "../../../../../assets/icons/ic_clip-path.svg";

import "./stylesCategoryRow.css";

import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  PlusOutlined,
  UpOutlined,
} from "@ant-design/icons";
import AddGamePopup from "./AddGamePopup/AddGamePopup";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import { message } from "antd";
import EditGameIconPopup from "../SortableItem/EditGameIconPopup/EditGameIconPopup";

const CategoryRow = ({
  category,
  setCasinoGames,
  order,
  toggleStatus,
  removeGame,
  setRemovingGameData,
  etype,
  allGames,
  addGameInCasinoEntity,
  categories,
  toggleCasinoEntityStatus,
  EditGameIcon,
  rows,
  columns,
}) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [isExpanded, setIsExpanded] = useState(false);
  const [isAddGamePopupVisible, setAddGamePopupVisible] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const sensors = useSensors(useSensor(PointerSensor));
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: category.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (!over) return;

    if (active.id !== over.id) {
      const game = category.games.find((game) => game.game_id === active.id);
      const oldIndex = category.games.findIndex(
        (game) => game.game_id === active.id
      );
      const newIndex = category.games.findIndex(
        (game) => game.game_id === over.id
      );
      const updatedGames = arrayMove(category.games, oldIndex, newIndex);

      setCasinoGames((prev) =>
        prev.map((cat) =>
          cat.id === category.id ? { ...cat, games: updatedGames } : cat
        )
      );
      await changeGameOrderForCasinoEntity({
        name: category.id,
        game_id: game.game_id,
        provider: game.provider,
        order: newIndex + 1,
        etype,
      });
    }
  };

  const changeGameOrderForCasinoEntity = async ({
    name,
    game_id,
    provider,
    order,
    etype,
  }) => {
    const params = { name, order, etype, game_id, provider };

    try {
      const res = await PrivateAdminPanelInstance.post(
        API_ROUTES.CHANGE_GAME_ORDER_FOR_CASINO_ENTITY,
        params
      );

      messageApi.success(res.data.message);
    } catch (error) {
      messageApi.error("error changing casino game order");
      console.log("error changing casino game order", error);
    } finally {
    }
  };

  return (
    <>
      {contextHolder}
      <AddGamePopup
        isVisible={isAddGamePopupVisible}
        onClosePressed={setAddGamePopupVisible}
        getEventCodesList={() => {}}
        allGames={allGames}
        ename={category.ename}
        addGameInCasinoEntity={addGameInCasinoEntity}
        categories={categories}
        etype={etype}
      />
      <tr
        ref={setNodeRef}
        style={style}
        {...attributes}
        className="category-row"
      >
        {rows.map((row, index) => {
          if (index === 0) {
            return (
              <td {...listeners} className="category-row__cell">
                <div className="category-row__cell-order">
                  <img src={ClipPath} alt="" />
                  {order}
                </div>
              </td>
            );
          }
          if (index === 1) {
            return (
              <td className="category-row__cell">
                <div className="category-row__live-icon">
                  <img src={category[row]} alt="" />
                </div>
              </td>
            );
          }
          if (row === "blank") {
            return <td className="category-row__cell"></td>;
          }
          if (row === "ename") {
            return <td className="category-row__cell">{category.ename}</td>;
          }
          if (row === "is_active") {
            return (
              <>
                <td className="category-row__cell">
                  <span
                    className={`status status-${
                      category.is_active ? "active" : "inactive"
                    }`}
                  >
                    {category.is_active ? "Active" : "Inactive"}
                  </span>
                </td>
                <td className="category-row__cell">
                  <div>
                    <ToggleSwitch
                      status={category.is_active}
                      eventCode={1}
                      updateEventCode={toggleCasinoEntityStatus}
                      data={category}
                      onlyUpdate={true}
                    />
                  </div>
                </td>
              </>
            );
          }
        })}
        <td className="category-row__cell">
          <button onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <DownOutlined /> : <UpOutlined />}
          </button>
        </td>
      </tr>

      {/* Games */}
      {isExpanded && (
        <>
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={category.games.map((game) => game.game_id)}
              strategy={verticalListSortingStrategy}
            >
              {category.games.map((game, index) => (
                <SortableItem
                  key={game.game_id}
                  game={game}
                  index={index}
                  order={order}
                  toggleStatus={toggleStatus}
                  removeGame={removeGame}
                  setRemovingGameData={setRemovingGameData}
                  name={category.ename}
                  etype={etype}
                  EditGameIcon={EditGameIcon}
                  columns={columns}
                />
              ))}
            </SortableContext>
          </DndContext>
          <tr className="category-row">
            {columns.map((column, index) => {
              if (index === 1) {
                return (
                  <td className="category-row__cell">
                    <button
                      className="add-game-button"
                      onClick={() => setAddGamePopupVisible(true)}
                    >
                      <PlusOutlined />
                      <span> Add Game </span>
                    </button>
                  </td>
                );
              } else {
                return <td className="category-row__cell"></td>;
              }
            })}
            <td className="category-row__cell"></td>
          </tr>
        </>
      )}
    </>
  );
};

export default CategoryRow;
